export default __webpack_public_path__ + "static/twitter-f87fab6e76b591c59da9102b72268ead.png";